import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { GROUPS_MANAGEMENT_URL } from '../../const/URL.const';
import IVenue from '../../interfaces/IVenue';
import { IReduxAppState } from '../../reducers';
import { HTTPMethods } from '../../yoello-lib/modules/API/API';
import { useSnackbarMessages } from '../../yoello-lib/modules/components/snackbar/SnackbarContext';
import { ILanguage } from '../../yoello-lib/modules/redux/actions/localization';
import { IVenueGroup } from './state/groupsManagement.reducer';
import { useVenueGroups } from './useVenueGroups'
import { useVenues } from './useVenues';
import { generateErrorMessage } from './util/generateErrorMessage';

export function useGeneralForm(dispatch?:any) {
  
  const { t } = useTranslation();
  const languages = useSelector(
    (state: IReduxAppState) => state.general.languages
  ) as ILanguage[];
  const history = useHistory();
  const { callGroups, id, settings, getGroupById } = useVenueGroups(dispatch);
  const { venues, setSearchText, isLoading } = useVenues();
  const { sendSnackbarMessage } = useSnackbarMessages()!!;

  

  function onDelete() {
    history.push(GROUPS_MANAGEMENT_URL)
  }

  function onSubmit(formData: any) {
    return new Promise(async (resolve, reject) => {
      if(formData.logo_group!== undefined){
        callGroups(HTTPMethods.PUT, {
          query: id,
          body: {
            logo_group: formData.logo_group
          },
        }).then((result) => {
          if (result.isSuccessful) {
            getGroupById(id).then(()=>{
              resolve(result.isSuccessful);
            }); 
          } else {
            reject("error")
          }
        });
      }else if (formData.multi_ordering_enabled!== undefined) {
        callGroups(HTTPMethods.PUT, {
          query: `${id}/settings/${settings?.group_settings.id}`,
          body: {
            multi_ordering_enabled: formData.multi_ordering_enabled
          },
        }).then((result) => {
          if (result.isSuccessful) {
            getGroupById(id).then(()=>{
              resolve(result.isSuccessful);
            }); 
          } else {
            sendSnackbarMessage(t(generateErrorMessage(result.data , false)), 'error');
            reject("error")
          }
        });
      } else {
        const { data , isSuccessful} = await callGroups(HTTPMethods.PUT, {
          query:id,
          body: {
            name_public:formData.name_public,
            description:formData.description,
            nickname:formData.nickname,
            language_id:formData.language_id
          }
        });
        if (isSuccessful && data ) {
          const { id } = data as IVenueGroup;
          const result = await callGroups(HTTPMethods.POST, {
            query: `${id}/venues/attach_detach`,
            body: {
              venue_group_id: id,
              venue_ids:formData.venues?.map((venue:IVenue) => venue.id)
            }
          });
          if(result.isSuccessful){
            getGroupById(id).then(()=>{
              resolve(result.isSuccessful);
            })
          }else{
            sendSnackbarMessage(t(generateErrorMessage(result.data , false)), 'error');
            reject("error")
          }
        }else{
          sendSnackbarMessage(t(generateErrorMessage(data , false)), 'error');
          reject("error")
        }
      }
    });
  };

  return {
    venues,
    languages,
    callGroups,
    onDelete,
    onSubmit,
    formData:settings,
    isLoading,
    setSearchText,
    t
  }
}
